import { render } from "./Click11PlusIcon.vue?vue&type=template&id=5aba67aa"
import script from "./Click11PlusIcon.vue?vue&type=script&lang=js"
export * from "./Click11PlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__